<template>
  <i></i>
</template>
<script>
import { isNativeFunExist } from '~/utils/util'
export default {
  computed: {
    game() {
      return this.$store.state.game.info
    },
    hasIco() {
      return (this.game.icon_url || '').includes('.ico')
    },
    game_id() {
      const { game_id } = this.$route.params
      return game_id
    }
  },
  mounted() {
    if (isThunder) {
      window.addEventListener('beforeunload', () => {
        this.unRegisterTabCloseFun()
      })

      this.registerTabCloseFun()
    }
  },
  methods: {
    unRegisterTabCloseFun() {
      this.isNativeTabCloseFunExist((isFunExist) => {
        if (isFunExist && this.game.jump_url) {
          window.native.CallNativeFunction(
            'TabBeforeClose',
            null,
            () => {},
            () => {}
          )
        }
      })
    },
    registerTabCloseFun() {
      this.isNativeTabCloseFunExist((isFunExist) => {
        if (isFunExist && this.game.jump_url) {
          window.native.CallNativeFunction(
            'TabBeforeClose',
            '{ "title": "是否收藏游戏至电脑？", "type": "warning", "content": "建议您收藏游戏至电脑，享受更好更流畅的游戏体验", "okText": "收藏游戏", "cancelText": "马上离开"}',
            (index) => {
              // 如果当前标签未选中,选中当前标签
              window.native.CallNativeFunction('IsTabSelected', (
                _ /* err */,
                selected
              ) => {
                if (!selected) {
                  window.native.CallNativeFunction('SelectTab', index)
                }
              })
              this.saveToDesktop()
              // 关闭当前tab
              setTimeout(() => {
                window.close()
              }, 200)
            },
            (err, ret) => {
              this.$sentry.error(err + ' ' + ret)
              // TabBeforeClose接口调用的返回值回调，由于规定最后一个回调函数为返回值回调，所以此处必须有个函数体
            }
          )
        }
      })
    },
    isValidAppVersion(version) {
      version = version || ''
      const array = version.split('.').map((e) => parseInt(e))
      if (array.length > 3) {
        if (
          array[0] > 10 ||
          (array[0] >= 10 && array[1] >= 1 && array[2] >= 26)
        ) {
          return true
        }
      }
      return false
    },
    isAppSuportWebShortcut() {
      // var appversion = '10.1.26.123';
      return new Promise((resolve, reject) => {
        window.native.CallNativeFunction(
          'GetThunderVersion',
          (errCode, version) => {
            if (errCode === 0) {
              if (this.isValidAppVersion(version)) {
                resolve({
                  support: true,
                  appversion: version
                })
              } else {
                resolve({
                  support: false,
                  appversion: version
                })
              }
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject('接口出错，请稍后重试' + '(' + errCode + ')')
            }
          }
        )
      })
    },
    isNativeTabCloseFunExist(callBack) {
      if (
        window.native &&
        window.native.CheckNativeFunction &&
        window.native.CallNativeFunction
      ) {
        window.native.CheckNativeFunction('TabBeforeClose', (err) => {
          const isFunExist = err !== 1
          callBack(isFunExist)
        })
      }
    },
    addParamsTo(url, key, value) {},
    saveToDesktop() {
      isNativeFunExist('CreateNewTask').then((res) => {
        if (res.support) {
          const options = {
            type: 'com',
            url: `${this.game.jump_url}`,
            stat: 'clipboard'
          }
          window.native.CallNativeFunction(
            'CreateNewTask',
            JSON.stringify({ '0': options }),
            // eslint-disable-next-line
            (err, data) => {}
          )
        } else {
          window.open(`${this.game.jump_url}`)
        }
      })
      this.$xlaGameReport(
        'dltab_startup_navigation_game_alter_click',
        {
          game_id: this.game_id,
          game_name: this.game.title,
          click_id: 'add_to_desk'
        },
        'download_detail'
      )
    }
  }
}
</script>
